import {
  mainColor,
  mainHover,
  mainLight,
  secondaryColor,
  secondaryHover,
  error,
  errorHover,
  mainText,
  darkBlueCrehana,
  purpleBlue,
  blueCrehana,
  lightBlue,
  darkAqua,
  aquaCrehana,
  lightAqua,
  darkGray,
  gray,
  gray2,
  lightGray,
  purpleGray,
  red,
  red2,
  red3,
  red4,
  green,
  green2,
  green3,
  green4,
  yellow,
  yellow2,
  yellow3,
  yellow4,
  white,
  black,
  mainColorRGB,
  mainHoverRGB,
  secondaryColorRGB,
  secondaryHoverRGB,
  errorRGB,
  errorHoverRGB,
  mainTextRGB,
  darkBlueCrehanaRGB,
  purpleBlueRGB,
  blueCrehanaRGB,
  lightBlueRGB,
  darkAquaRGB,
  aquaCrehanaRGB,
  lightAquaRGB,
  darkGrayRGB,
  grayRGB,
  gray2RGB,
  lightGrayRGB,
  purpleGrayRGB,
  whiteRGB,
  blackRGB,
  redRGB,
  red2RGB,
  red3RGB,
  red4RGB,
  greenRGB,
  green2RGB,
  green3RGB,
  green4RGB,
  yellowRGB,
  yellow2RGB,
  yellow3RGB,
  yellow4RGB,
  selectActive,
} from './colors';

const palette = {
  primary: {
    light: mainLight,
    main: mainColor,
    dark: mainHover,
  },
  secondary: {
    light: secondaryColor,
    main: secondaryColor,
    dark: secondaryHover,
  },
  error: {
    light: error,
    main: error,
    dark: errorHover,
  },
  text: {
    primary: mainText,
  },
  common: {
    white,
    black,
  },
  // Rebranding
  purple: {
    darker: darkBlueCrehana,
    dark: purpleBlue,
    main: blueCrehana,
    light: lightBlue,
    main05: selectActive, // (05% opacity)
  },
  aqua: {
    dark: darkAqua,
    main: aquaCrehana,
    light: lightAqua,
  },
  gray: {
    dark: darkGray,
    main: gray,
    main2: gray2,
    light: lightGray,
    purple: purpleGray,
  },
  red: {
    1: red,
    2: red2,
    3: red3,
    4: red4,
  },
  green: {
    1: green,
    2: green2,
    3: green3,
    4: green4,
  },
  yellow: {
    1: yellow,
    2: yellow2,
    3: yellow3,
    4: yellow4,
  },
  rgba: {
    primary: {
      light: opacity => `rgba(127, 203, 255,${opacity})`,
      main: opacity => `rgba(${mainColorRGB},${opacity})`,
      dark: opacity => `rgba(${mainHoverRGB},${opacity})`,
    },
    secondary: {
      light: opacity => `rgba(${secondaryColorRGB},${opacity})`,
      main: opacity => `rgba(${secondaryColorRGB},${opacity})`,
      dark: opacity => `rgba(${secondaryHoverRGB},${opacity})`,
    },
    error: {
      light: opacity => `rgba(${errorRGB},${opacity})`,
      main: opacity => `rgba(${errorRGB},${opacity})`,
      dark: opacity => `rgba(${errorHoverRGB},${opacity})`,
    },
    text: {
      primary: opacity => `rgba(${mainTextRGB},${opacity})`,
    },
    common: {
      black: opacity => `rgba(${blackRGB},${opacity})`,
      white: opacity => `rgba(${whiteRGB},${opacity})`,
    },
    // Rebranding
    purple: {
      darker: opacity => `rgba(${darkBlueCrehanaRGB},${opacity})`,
      dark: opacity => `rgba(${purpleBlueRGB},${opacity})`,
      main: opacity => `rgba(${blueCrehanaRGB},${opacity})`,
      light: opacity => `rgba(${lightBlueRGB},${opacity})`,
    },
    aqua: {
      dark: opacity => `rgba(${darkAquaRGB},${opacity})`,
      main: opacity => `rgba(${aquaCrehanaRGB},${opacity})`,
      light: opacity => `rgba(${lightAquaRGB},${opacity})`,
    },
    gray: {
      dark: opacity => `rgba(${darkGrayRGB},${opacity})`,
      main: opacity => `rgba(${grayRGB},${opacity})`,
      main2: opacity => `rgba(${gray2RGB},${opacity})`,
      light: opacity => `rgba(${lightGrayRGB},${opacity})`,
      purple: opacity => `rgba(${purpleGrayRGB},${opacity})`,
    },
    red: {
      1: opacity => `rgba(${redRGB},${opacity})`,
      2: opacity => `rgba(${red2RGB},${opacity})`,
      3: opacity => `rgba(${red3RGB},${opacity})`,
      4: opacity => `rgba(${red4RGB},${opacity})`,
    },
    green: {
      1: opacity => `rgba(${greenRGB},${opacity})`,
      2: opacity => `rgba(${green2RGB},${opacity})`,
      3: opacity => `rgba(${green3RGB},${opacity})`,
      4: opacity => `rgba(${green4RGB},${opacity})`,
    },
    yellow: {
      1: opacity => `rgba(${yellowRGB},${opacity})`,
      2: opacity => `rgba(${yellow2RGB},${opacity})`,
      3: opacity => `rgba(${yellow3RGB},${opacity})`,
      4: opacity => `rgba(${yellow4RGB},${opacity})`,
    },
  },
};

export default palette;
